import { render, staticRenderFns } from "./DeleteLinkPopup.vue?vue&type=template&id=e0fc0582&scoped=true&"
import script from "./DeleteLinkPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteLinkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLinkPopup.vue?vue&type=style&index=0&id=e0fc0582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc0582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0fc0582')) {
      api.createRecord('e0fc0582', component.options)
    } else {
      api.reload('e0fc0582', component.options)
    }
    module.hot.accept("./DeleteLinkPopup.vue?vue&type=template&id=e0fc0582&scoped=true&", function () {
      api.rerender('e0fc0582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/DeleteLinkPopup.vue"
export default component.exports